import store from '~/store'
import {roles} from "../plugins/utils";

export default (to, from, next) => {
  if (store.state.auth.user.role === roles.SELLER) {
    next()
  } else {
    next({name: 'home'})
  }
}
